<template>
  <section>
    <div class="movie-panel" :data-doc-id="movieData.docID" :data-class="movieData.class">

      <!-- Watch Links Overlay -->
      <div class="watch-links-overlay overlay-outer" v-if="watchLinksActive">
        <div class="watch-links-inner overlay-inner">
          <a href="#" v-on:click.stop.prevent="closeWatchLinks" class="modal-close"><i class="fal fa-times"></i></a>
          <h3>This is available to watch on</h3>
<!--           <div v-if="movieData.AmazonLinks == undefined && movieData.YouTubeLinks == undefined && movieData.iTunesLinks == undefined">
            Unfortuntely we have no provider links for this movie at this time
          </div> -->
          <div class="price-list amazon-links">
            <ul>
              <li v-for="link in movieData.AmazonLinks" :data-type="link.monetization_type + '-' + link.presentation_type"><a :href="link.urls.standard_web" class="pure-button" target="_blank">
                <div class="logo-wrap"><img src="../assets/img/amazon-prime-video.png" /></div> <span :data-currency="link.currency">{{link.retail_price}}</span></a></li>
            </ul>
          </div>
          <div class="price-list youtube-links" v-if="YouTube.videoId">
            <ul>
              <li><a :href="'https://www.youtube.com/watch?v=' + YouTube.videoId" class="pure-button" target="_blank"><div class="logo-wrap"><img src="../assets/img/youtube-logo.png" /></div></a></li>
            </ul>
          </div>
          <div class="price-list itunes-links" v-if="iTunes">
            <ul>
              <li><a :href="iTunes.url" class="pure-button" target="_blank"><div class="logo-wrap"><img src="../assets/img/uk-itunes-badge.png" class="itunes-logo" /></div> <span :data-currency="iTunes.currency" v-if="iTunes.price">{{iTunes.price}}</span></a></li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Add To List Overlay -->
      <div class="add-to-list-panel list-switch-panel overlay-outer" v-if="showListAdd">
        <div class="add-to-list-inner not-logged-in-inner overlay-inner group" v-if="!isLoggedIn">
          <a href="#" v-on:click.stop.prevent="closeListAdd" class="modal-close"><i class="fal fa-times"></i></a>
          <h3>Please login to add this movie to a list.</h3>
          <router-link to="/account" class="pure-button login-register-button">Login or Register</router-link>
        </div>
        <div class="add-to-list-inner overlay-inner" v-else>
          <a href="#" v-on:click.stop.prevent="closeListAdd" class="modal-close"><i class="fal fa-times"></i></a>
          <h3>Add this to one of your lists</h3>
          <button class="pure-button new-list-button" v-on:click="toggleNewListForm">New list</button>
          <div class="pure-form pure-form-stacked" v-if="showListForm">
            <div class="input-field">
              <input name="new_list" placeholder="Name your new list..." id="new_list" type="text" class="validate tooltip" v-model="newListName" autocomplete="off" v-on:keyup.enter="createList">
              <div v-on:click="createList" class="add-list-trigger"><i class="fal fa-plus-circle"></i><i class="fas fa-circle-notch fa-spin"></i></div>
            </div>
          </div>
          <ul class="user-lists group">
            <li v-for="list in lists" :data-id="list.id" v-on:click="addToList(list.id, list.name)">
              <div class="movie-poster">
                <img :src="list.Poster" :alt="list.name" v-if="list.Poster" />
                <div class="movie-poster-holder" v-else></div>
              </div>
              <div class="list-title">
                <div class="list-title-inner">{{list.name}}</div>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <!-- Rate Movie Overlay -->
      <div class="rate-movie-panel overlay-outer" v-if="showMovieRate">
        <div class="rate-movie-inner overlay-inner group" v-if="!isLoggedIn">
          <a href="#" v-on:click.stop.prevent="closeMovieRate" class="modal-close"><i class="fal fa-times"></i></a>
          <h3>Please login to rate this movie.</h3>
          <router-link to="/account" class="pure-button login-register-button">Login or Register</router-link>
        </div>
        <div class="rate-movie-inner overlay-inner" v-else>
          <a href="#" v-on:click.stop.prevent="closeMovieRate" class="modal-close"><i class="fal fa-times"></i></a>
          <h3>Rate films to see how you compare to Matrix</h3>
          <h5>What did you think of {{movieData.Title}}?</h5>
          <div class="meta-wrap rate-meta-wrap group">
            <div class="quality-square user-score-square">
              <span class="score user-score" id="rate-user-score">...</span>
              <span>You</span>
            </div>
            <div class="quality-square">
              <span class="score">{{movieData.Quality}}</span>
              <span>Quality</span>
            </div>
          </div>
          <div id="rate-slider"></div>
          <button class="pure-button rate-film-button" v-on:click.stop.prevent="rateMovie">Rate film</button>
        </div>
      </div>

      <!-- Add Note Overlay -->
      <div class="add-note-panel overlay-outer" v-if="showAddNote">
        <div class="add-note-inner overlay-inner group" v-if="!isLoggedIn">
          <a href="#" v-on:click.stop.prevent="closeAddNote" class="modal-close"><i class="fal fa-times"></i></a>
          <h3>Please login to add a note to this movie.</h3>
          <router-link to="/account" class="pure-button login-register-button">Login or Register</router-link>
        </div>
        <div class="add-note-inner overlay-inner" v-else>
          <a href="#" v-on:click.stop.prevent="closeAddNote" class="modal-close"><i class="fal fa-times"></i></a>
          <h4>What did you think of {{movieData.Title}}?</h4>
          <textarea name="add_note" placeholder="Type your note here" id="add_note" type="text" class="validate" autocomplete="off" maxlength="50" v-model="newMovieNote" v-on:keyup.enter="addNote"></textarea>
          <div class="button-wrap">
            <button v-on:click="addNote" class="pure-button add-note-trigger">Add Note</button>
          </div>
          <h5>Notes on this film</h5>
          <ul class="movie-notes-list">
            <li v-for="note in movieNotes" :id="'note-' + note.id">
              <div class="user">{{note.username}}: <!-- <i class="fal fa-times" v-on:click="movieNoteDelete(note.id)"></i> --></div>
              <div class="note-text">{{ note.text }}</div>
            </li>
          </ul>
        </div>
      </div>

      <div class="title-bar">
        <h3>{{movieData.Title}} <span>({{movieData.Year}})</span></h3>
        <a href="#" class="back-button" v-on:click.stop.prevent="moviePanelHide()" v-if="!isSearch"><i class="fal fa-long-arrow-left"></i></a>
      </div>
      <div class="movie-img-meta group">
        <div class="img-wrap">
          <img :src="movieData.Poster" :alt="movieData.Title"  />
        </div>
        <div class="meta-wrap">
          <div class="quality-square">
            <span class="score">{{movieData.Quality}}</span>
            <span>Quality</span>
          </div>
          <div class="quality-square">
            <span class="score">{{movieData.Buzz}}</span>
            <span>Buzz</span>
          </div>
          <div class="director meta-list"><span>Directed by</span>:
            <ul>
              <li v-for="director in movieData.Directors" :data-id="director" v-on:click="doMovieSearch(director, 'Directors')">{{director}}</li>
            </ul>
          </div>
          <div class="cast meta-list"><span>Starring</span>:
          <ul>
            <li v-for="cast in movieData.Cast" :data-id="cast" v-on:click="doMovieSearch(cast, 'Cast')">{{cast}}</li>
          </ul>
          </div>
          <div class="genre meta-list">
            <ul>
              <li v-for="genre in movieData.Genres" :data-id="genre" v-on:click="doMovieSearch(genre, 'Genres')">{{genre}}</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="button-group group">
        <button class="pure-button trailer-link" :data-video-id="movieData.videoID" v-on:click.stop.prevent="viewTrailer(movieData.videoID)">View trailer</button>
        <button class="pure-button watch-this no-links" v-on:click.stop.prevent="watchThis()" v-if="movieData.AmazonLinks == undefined && movieData.YouTubeLinks == undefined && movieData.iTunesLinks == undefined"><i class="fal fa-video"></i> Watch this</button>
        <button class="pure-button watch-this" v-on:click.stop.prevent="watchThis()" v-else><i class="fal fa-video"></i> Watch this</button>
      </div>
      <div class="plot-wrap">{{movieData.Plot}}</div>
      <div class="consensus-wrap">{{movieData.RTConsensus}}</div>
      <div class="button-group group">
        <button class="pure-button add-to-list-link small-button first-small-button" v-on:click.stop.prevent="showListsForAdd(movieData.docID, movieData.Title)"><i class="fal fa-bars"></i> Add to list</button>
        <button class="pure-button rate-film-link small-button" v-on:click.stop.prevent="openMovieRate()" v-if="!isRated"><i class="fas fa-bolt"></i> Rate film</button>
        <button class="pure-button rate-film-link rate-button-is-rated small-button" v-on:click.stop.prevent="openMovieRate()" v-if="isRated">You rated <span>{{ratingValue}}</span></button>
        <button class="pure-button add-note-link small-button last-small-button" v-on:click.stop.prevent="openAddNote()"><i class="fal fa-bookmark"></i> Add note</button>
      </div>
    </div>
  </section>
</template>

<script>
  /* global $, algoliasearch, noUiSlider, wNumb */
  import Request from 'superagent'
  import 'vuejs-noty/dist/vuejs-noty.css'
  import db from './firebaseInit'
  import JustWatch from 'justwatch-api'
  import firebase from 'firebase'
  const fs = require('fs');
  const itunesSearchApi = require('itunes-search-api');

  export default {
    name: 'moviePanel',
    data () {
      return {
        lists: [],
        showListAdd: false,
        showListForm: false,
        watchLinksActive: false,
        showMovieRate: false,
        newListName: '',
        currentUserID: this.$globals.currentUserID,
        isLoggedIn: false,
        ratingValue: 50,
        isRated: false,
        ratingDocID: null,
        iTunes: {},
        YouTube: {},
        showAddNote: false,
        newMovieNote: '',
        movieNotes: []
      }
    },
    props: {
      movieData: {
        type: Object,
        required: false,
        mustProcess: false
      },
      isSearch: false,
      isSelected: false,
      isList: false
    },
    created () {
      let vm = this
      firebase.auth().onAuthStateChanged(function (user) {
        if (user) {
          vm.currentUserID = user.uid
          vm.isLoggedIn = true
          vm.checkMovieIsRated()
        }
      })

      // get provider data
      // this.getProviderData()

      // fix poster
      if (this.movieData && this.movieData.PosterPath) {
        this.movieData.Poster = 'https://image.tmdb.org/t/p/w342/' + this.movieData.PosterPath.replace(/ /g, "")
      }

      // set class
      if (this.movieData.Quality >= 75 && this.movieData.Buzz >= 75) {
        this.movieData.class = 'high'
      } else if (this.movieData.Quality >= 75 && this.movieData.Buzz >= 25) {
        this.movieData.class = 'mid'
      } else {
        this.movieData.class = 'low'
      }

      // get video ID
      this.getVideoID()
    },
    watch: {
      movieData() {
        this.getVideoID()
      }
    },
    methods: {
      getProviderData: function () {
        var vm = this
        var jw = new JustWatch

        jw.search({query: this.movieData.Title}).then(result => {
            if (result.items && result.items.length > 0) {
              var firstResult = result.items[0]
              console.log(firstResult)
              var offers = firstResult.offers
              vm.amazonLinks = offers.filter(obj => {
                return obj.provider_id === 10
              })
              vm.youtubeLinks = offers.filter(obj => {
                return obj.provider_id === 192
              })
              vm.itunesLinks = offers.filter(obj => {
                return obj.provider_id === 2
              })
            }
        }).catch(err => {
            console.log(err)
        })
      },
      getYouTubeData: function () {
        let vm = this
        const YouTubeAPIKey = 'AIzaSyBkrw2uZPt9gYKYMPgokAtIOVE38ucY40U'
        const searchTerm = encodeURIComponent(vm.movieData.Title)
        const req = Request
        .get('https://www.googleapis.com/youtube/v3/search?part=snippet&channelId=UCH3Q5ElbCSTRu1PJr5OdhPw&maxResults=1&q=' + searchTerm + '&type=video&videoCategoryId=30&fields=etag%2CeventId%2Citems%2Ckind%2CnextPageToken%2CpageInfo%2CprevPageToken%2CregionCode%2CtokenPagination%2CvisitorId&key=' + YouTubeAPIKey)
        //.query({ segment_id: vm.segment1aday })
        .then(function(res) {
          var data = JSON.parse(res.text)
          if (data.pageInfo.totalResults > 0) {
            var result = data.items[0]
            console.log(result)
            vm.YouTube = {
              videoId: result.id.videoId
            }
            console.log(vm.YouTube)
          }
        })
      },
      getiTunesData: function () {
        let vm = this

        const opts = {
            query: {
                entity: 'movie',
                country: 'GB',
                limit: 1
            }
        };
         
        itunesSearchApi(vm.movieData.Title, opts).then(res => {
            console.log(res.body);
            var resultCount = res.body.resultCount
            var result = res.body.results[0]
            if (resultCount == 1) {
              vm.iTunes = {
                url: result.trackViewUrl,
                price: result.trackRentalPrice ? result.trackRentalPrice : result.trackPrice,
                currency: result.currency
              }
            }
            //=> {resultCount: 1, results: [{...}]}
        });
      },
      getVideoID: function () {
        let vm = this
        if (vm.movieData.imdbID) {
          const req = Request
          .get('https://api.themoviedb.org/3/movie/' + vm.movieData.imdbID + '/videos?api_key=3e3ce1f6731cc0cfdc3596f411aea03f')
          //.query({ segment_id: vm.segment1aday })
          .then(function(res) {
            var data = JSON.parse(res.text)
            if (data.results[0]) {
              vm.movieData.videoID = data.results[0].key
            }
          })
        }
      },
      doMovieSearch: function (triggeredSearch, triggeredField) {
        if (this.isSelected) {
          this.$eventHub.$emit('do-movie-search-selected', triggeredSearch, triggeredField)         
        } else if (this.isList) {
          this.$router.push({ path: '/', query: { qSearchField: triggeredField, qSearchValue: triggeredSearch} })
        } else {
          this.$eventHub.$emit('do-movie-search', triggeredSearch, triggeredField)         
        }
      },
      watchThis: function () {
        this.getiTunesData()
        this.getYouTubeData()
        this.watchLinksActive = true
      },
      closeWatchLinks: function () {
        this.watchLinksActive = false
      },
      checkMovieIsRated: function () {
        let vm = this
        if (vm.currentUserID) {
          var ratingRef = db.collection('movieRatings').where('movieID', '==', vm.movieData.id).where('userID', '==', vm.currentUserID).limit(1)
          ratingRef.get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              if (doc.exists) {
                vm.isRated = true
                vm.ratingDocID = doc.id
                var ratingData = doc.data()
                vm.ratingValue = ratingData.rating
              }
            })
          })
        }
      },
      openMovieRate: function () {
        let vm = this

        // open overlay
        vm.showMovieRate = true

        // create slider
        setTimeout(function () {
          var slider = document.getElementById('rate-slider');
          noUiSlider.create(slider, {
            start: [vm.ratingValue],
            range: {
              'min': 0,
              'max': 100
            },
            format: wNumb({
              decimals: 0,
              thousand: '',
              suffix: '',
            })
          });

          var rangeSliderValueElement = document.getElementById('rate-user-score');

          slider.noUiSlider.on('update', function( values, handle ) {
            rangeSliderValueElement.innerHTML = values[handle];
            vm.ratingValue = values[handle]
          });
        }, 100)
      },
      rateMovie: function () {
        let vm = this
        console.log(vm.ratingDocID)
        if (vm.isRated) {
          var ratingRef = db.collection('movieRatings').doc(vm.ratingDocID)
          const timestamp = firebase.firestore.FieldValue.serverTimestamp()
          var updateRatingData = {
            rating: vm.ratingValue,
            updatedTimestamp: timestamp,
            username: vm.$globals.userUsername,
          }
          ratingRef.update(updateRatingData)
          .then(function () {
            console.log('Document rating updated')
            vm.showMovieRate = false
          })
          .catch(function (error) {
            console.error('Error updating document: ', error)
          })
        } else {
          const timestamp = firebase.firestore.FieldValue.serverTimestamp()
          var ratingData = {
            rating: vm.ratingValue,
            movieID: vm.movieData.id,
            userID: vm.currentUserID,
            username: vm.$globals.userUsername,
            createdTimestamp: timestamp
          }
          db.collection('movieRatings').add(ratingData)
          .then(function (docRef) {
            console.log('Document written with ID: ', docRef.id)
            vm.isRated = true
            vm.ratingDocID = docRef.id
            vm.showMovieRate = false
          })
          .catch(function (error) {
            console.error('Error adding document: ', error)
          })
        }
      },
      closeMovieRate: function () {
        this.showMovieRate = false
      },
      openAddNote: function () {
        this.showAddNote = true
        this.getMovieNotes()
      },
      addNote: function () {
        $('#add_note').prop('disabled', true)
        let vm = this
        let userID = vm.currentUserID
        let noteData = {
          'movieID': this.movieData.id,
          'userID': userID,
          'username': vm.$globals.userUsername,
          'text': vm.newMovieNote,
          'createdTimestamp': firebase.firestore.FieldValue.serverTimestamp()
        }
        mixpanel.track(
          'Create grape note',
          {
            'grapeID': vm.selectedGrapeID
          }
        )
        db.collection('movieNotes').add(noteData).then(function (docRef) {
          console.log('Document written with ID: ', docRef.id)
          vm.$noty.success('Note added to movie')
          vm.newMovieNote = ''
          vm.movieNotes.push(noteData)
          $('#add_note').prop('disabled', false)
        }).catch(function (error) {
          console.error('Error adding document: ', error)
          $('#add_note').prop('disabled', false)
        })
      },
      getMovieNotes: function () {
        let vm = this
        vm.movieNotes = []
        var notesRef = db.collection('movieNotes').where('movieID', '==', vm.movieData.id)
        notesRef.get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            var noteData = doc.data()
            noteData.id = doc.id
            if (vm.currentUserID == noteData.userID) {
              noteData.isOwner = true
            }
            vm.movieNotes.push(noteData)
          })
        })
      },
      closeAddNote: function () {
        this.showAddNote = false
      },
      viewTrailer: function (videoID) {
        this.$eventHub.$emit('load-movie-trailer', videoID)
      },
      closeTrailerOverlay: function () {
        this.viewingTrailer = false
        $('#video-overlay').find('.video-wrap').empty()
      },
      getLists: function () {
        console.log('getLists')
        let vm = this
        if (vm.currentUserID) {
          var listsRef = db.collection('lists').orderBy('createdTimestamp', 'asc').where('userID', '==', vm.currentUserID)
          listsRef.get().then((querySnapshot) => {
            console.log('created query: ' + querySnapshot.docs.length)
            querySnapshot.forEach((doc) => {
              var listData = doc.data()
              listData.id = doc.id
              listData.docID = doc.id
              if (!vm.checkPresentInArray(vm.lists, listData.id, true)) {          
                // vm.lists.push(listData)
                vm.getListImage(listData)
              }
            })
          })
        }
      },
      getListImage: function (list) {
        let vm = this
        if (list.films && list.films.length > 0 && !list.Poster) {
          db.collection('movies').where('id', '==', list.films[0]).get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              var movieData = doc.data()
              list.Poster = 'https://image.tmdb.org/t/p/w342/' + movieData.PosterPath.replace(/ /g, "")
              vm.lists.push(list)
            })
          })
        } else {
          vm.lists.push(list)
        }
      },
      checkPresentInArray: function (inArr, ID, exists) {
        for (var i = 0; i < inArr.length; i++) {
          if (inArr[i].docID === ID) {
            return (exists === true) ? true : inArr[i]
          }
        }
      },
      showListsForAdd: function (filmID, filmTitle) {
        console.log('show list add')
        if (this.showListAdd) {
          this.showListAdd = false
        } else {
          this.getLists()
          this.showListAdd = true
          this.currentFilmID = filmID
          this.currentFilmTitle = filmTitle
        }
      },
      addToList: function (listID) {
        let vm = this
        let filmID = vm.currentFilmID
        let listRef = db.collection('lists').doc(listID)
        listRef.get().then(function (doc) {
          if (doc.exists) {
            var films = doc.data().films
            if ($.inArray(filmID, films) === -1) {
              films.push(filmID)
              listRef.update({
                films: films
              })
              vm.listFilmIDs = films
              vm.$eventHub.$emit('movie-panel-added-to-list', listID)
            }
            vm.showListAdd = false
            vm.$noty.success(vm.currentFilmTitle + ' added to list')
            $('.add-to-list-link').text('Added')
            setTimeout(function () {
              $('.add-to-list-link').text('Add to List')
            }, 3000)
          }
        })
      },
      closeListAdd: function () {
        this.showListAdd = false
      },
      toggleNewListForm: function () {
        if (this.showListForm) {
          this.showListForm = false
        } else {
          this.showListForm = true
        }
      },
      createList: function () {
        let vm = this
        if (this.newListName && this.newListName.length < 3) {
          return
        }
        if (!vm.isAddingList && this.newListName.length >= 3) {
          vm.isAddingList = true
          let listName = this.newListName
          let userID = this.currentUserID
          $('#new_list').prop('disabled', true)
          $('.add-list-trigger').addClass('is-adding')
          let listData = {
            'name': listName,
            'films': [],
            'createdTimestamp': firebase.firestore.FieldValue.serverTimestamp(),
            'userID': userID,
            'username': vm.$globals.userUsername
          }
          mixpanel.track(
            'Created list',
            {
              'listName': listName
            }
          )
          db.collection('lists').add(listData).then(function (docRef) {
            console.log('Document written with ID: ', docRef.id)
            vm.getLists(false)
            vm.listFilms = []
            vm.listFilmIDs = []
            vm.currentListID = docRef.id
            vm.currentListName = listName
            vm.newListName = ''
            vm.showListSwitch = false
            setTimeout(function () {
              vm.isAddingList = false
              vm.showListForm = false
              vm.addToList(docRef.id)
              $('#new_list').prop('disabled', false)
              $('.add-list-trigger').removeClass('is-adding')
              $('.user-lists').scrollTop($('.user-lists').prop("scrollHeight"))
            }, 500)
          })
        }
      },
      moviePanelHide: function () {
        this.$eventHub.$emit('hide-movie-panel', this.movieData.id)
      }
    },
    mounted () {
    }
  };
</script>

<style lang="scss">
  .noUi-horizontal .noUi-handle {
    background: #397EBF;
    box-shadow: none;
    border: 0;
    border-radius: 0;
    width: 20px;
    height: 24px;
    top: -7px;
    background: #758CA6;

    &:before, &:after {
      display: none;
    }
  }
  .noUi-target {
    border-radius: 0;
    background: #E3E9F0;
    border: 0;
    box-shadow: none;
  }
  .noUi-horizontal {
    height: 10px;
  }
  html:not([dir=rtl]) .noUi-horizontal .noUi-handle {
    right: -10px;
  }
</style>

<style lang="scss" scoped>
  .overlay-outer {
    position: fixed;
    background: rgba(0,0,0,0.8);
    width: 100vw;
    height: 100vh;
    left: 0;
    z-index: 999;
    overflow: hidden;
    padding: 5vh 0;
    bottom: 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;

    .overlay-inner {
      max-width: 360px;
      margin: 0 auto;
      background: #fff;
      padding: 30px;
      box-sizing: border-box;
      position: relative;
      margin-top: 20vh;
      
      .modal-close {
        position: absolute;
        top: -50px;
        right: -10px;
        width: 38px;
        font-size: 32px;
        color: #fff;
      }

      h3 {
        font-size: 22px;
      }

      .login-register-button {
        background: #296486;
        color: #fff;
        padding: 12px 20px;
      }
    }
  }
  .price-list {
    clear: both;

    ul {
      list-style: none;
      margin: 10px 0;
      padding: 0;
      height: auto;
      overflow: hidden;

      li {
        margin: 0;
        padding: 0;
        width: 100%;
        box-sizing: border-box;
        height: auto;
        overflow: hidden;

        a {
          display: block;
          box-sizing: border-box;
          background: transparent;
          border: 1px solid #ccc;
          border-radius: 3px;
          height: auto;
          overflow: hidden;

          .logo-wrap {
            width: 50%;
            text-align: center;
            float: left;
            
            img {
              max-height: 24px;
              width: auto;
              padding: 10px;
              display: inline-block;
              vertical-align: middle;
            }

            img.itunes-logo {
              max-height: 34px;
              padding: 5px;
            }
          }

          span {
            font-weight: bold;
            line-height: 44px;
            display: inline-block;
            font-size: 18px;
          }

          span[data-currency="USD"]::before {
            content: '$';
            position: relative;
            display: inline-block;
          }

          span[data-currency="GBP"]::before {
            content: '£';
            position: relative;
            display: inline-block;
          }
        }
      }

      li:first-child {
        margin-top: 0;
      }

      li[data-type="buy-sd"], li[data-type="buy-hd"], li[data-type="rent-hd"], li[data-type="buy-4k"], li[data-type="rent-4k"] {
        display: none;
      }
    }

    ul:empty {
      margin-top: 0;
    }
  } /* end .price-list */

  .youtube-links {
    .logo-wrap {
      width: 100%!important;
    }
  }

  .add-to-list-panel {

    .add-to-list-inner {

      h3 {
        margin: 0 0 15px;
        font-size: 16px;
        float: left;
        line-height: 36px;
      }

      .new-list-button {
        float: right;
        background: #2C3E50;
        color: #fff;
        font-size: 13px;
        padding: 9px 12px;
        border-radius: 0;
      }

      .pure-form-stacked {
        clear: both;
        position: absolute;
        top: 70px;
        right: 30px;
        width: 290px;
        box-sizing: border-box;

        input {
          width: 100%;
          border-radius: 0;
          padding: 16px 24px;
          font-size: 14px;
          box-shadow: 0px 0px 10px -3px rgba(0,0,0,0.5);
          border: 0;
        }

        .add-list-trigger {
          position: absolute;
          right: 15px;
          top: 50%;
          margin-top: -11px;
          cursor: pointer;
          font-size: 18px;
          

          i.fa-circle-notch {
            display: none;
          }
          
          &.is-adding i {
            display: none;
          }

          &.is-adding i.fa-circle-notch {
            display: inline-block;
          }
        }
      }
    }
  }

  .user-lists {
    margin: 0 -2px;
    padding: 0;
    list-style: none;
    max-height: 50vh;
    overflow-y: scroll;
    clear: both;

    li {
      float: left;
      width: 31.9%;
      margin: 0 2px 15px;
      cursor: pointer;
      
      .list-title {
        background: #2C3E50;
        color: #fff;
        padding: 10px;
        font-size: 13px;
        text-align: center;
        height: 90px;
        display: table;
        width: 100%;
        box-sizing: border-box;
        max-lines: 3;
      }
      .list-title-inner {
        display: table-cell;
        vertical-align: middle;
        word-break: break-word;
      }
      .movie-poster {
        max-height: 110px;
        margin-bottom: 5px;
        display: block;
        overflow: hidden;
        cursor: pointer;
        
        img {
          width: 100%;
          height: auto;
          display: block;
        }
      }
      .movie-poster-holder {
        height: 110px;
        background: #eee;
      }
    }
  } /* end .user-lists */

  .rate-movie-panel {

    .rate-movie-inner {
      text-align: center;

      h3 {
        margin: 0 0 20px;
        font-size: 14px;
      }

      h5 {
        font-weight: normal;
      }
    }

    .rate-meta-wrap {
      float: none!important;
      width: 100%!important;
      margin-bottom: 20px;
      
      .user-score-square {
        background: #2B3E4F!important;
      }
    }

    #rate-slider {
      margin-bottom: 30px;
    }

    .rate-film-button {
      background: #307FAB;
      color: #fff;
      padding: 12px 25px;
      border-radius: 0;
      font-size: 14px;
    }
  }

  .not-logged-in-inner {
    text-align: center;

    h3 {
      float: none!important;
    }
  }

  .add-note-inner {
    textarea {
      width: 100%;
      padding: 15px;
      margin-bottom: 15px;
      box-sizing: border-box;
      border: 1px solid #3a88b8;
      font-size: 0.9em;
    }
    .button-wrap {
      text-align: center;
    }
    .add-note-trigger {
      width: 50%;
      display: inline-block;
      background: #3a88b8;
      color: #fff;
      padding: 10px 12px;
    }
    h4 {
      font-weight: bold;
    }
    h5 {
      font-weight: bold;
      font-size: 0.9em;
      margin-bottom: 15px;
    }
    .movie-notes-list {
      list-style: none;
      margin: 0;
      padding: 0;

      li {
        margin-bottom: 10px;
      }
      .user {
        display: inline-block;
        font-weight: bold;
      }
      .note-text {
        display: inline-block;
      }
    }
  }

</style>

<style scoped>
  .movie-panel {
    position: relative;
  }
  .movie-panel .title-bar {
    position: relative;
    border-bottom: 1px solid #eaeaea;
    margin-bottom: 20px;
    padding-bottom: 10px;
  }
  .movie-panel .title-bar h3 {
    margin: 0;
    padding-right: 50px;
    font-size: 1.4em;
  }
  .movie-panel .title-bar h3 span {
    font-size: 0.7em;
  }
  .movie-panel .title-bar a {
    position: absolute;
    right: 0;
    top: 0;
    padding: 2px 10px;
    font-size: 1.2em;
    color: #627F8B;
  }
  .movie-panel .img-wrap {
    width: 40%;
    float: left;
  }
  .movie-panel .img-wrap img {
    width: 100%;
    height: auto;
  }
  .movie-panel .meta-wrap {
    width: 55%;
    float: right;
    text-align: center;
  }
  .movie-panel .meta-wrap span {
    text-decoration: underline;
  }
  .movie-panel .quality-square {
    display: inline-block;
    margin: 0 3px 20px;
    text-align: center;
    background: #747474;
    color: #fff;
    width: 50px;
    text-align: center;
    padding: 10px;
  }
  .movie-panel[data-class="high"] .quality-square {
    background: #397EBF;
  }
  .movie-panel[data-class="mid"] .quality-square {
    background: #EA953F;
  }
  .movie-panel .quality-square span {
    text-decoration: none;
    font-size: 0.8em;
    text-transform: uppercase;
  }
  .movie-panel .quality-square span.score {
    display: block;
    line-height: 24px;
    text-align: center;
    font-size: 1.5em;
    font-weight: bold;
    margin: 5px 0;
  }
  .movie-panel .director, .movie-panel .cast, .movie-panel .genre {
    text-align: left;
    margin-bottom: 10px;
    font-size: 0.85em;
  }
  .movie-panel .genre {
    text-align: right;
  }
  .movie-panel .director a {
    text-decoration: none;
    color: inherit;
  }
  .movie-panel .meta-wrap a {
    color: #397EBF;
  }
  .movie-panel .meta-wrap a:hover, .movie-panel .meta-list ul > li:hover {
    opacity: 0.7;
  }
  .movie-panel .meta-list ul {
    display: inline;
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .movie-panel .meta-list ul > li {
    display: inline;
    cursor: pointer;
    color: #397EBF;
  }
  .movie-panel .meta-list ul > li:after {
    content: ', ';
  }
  .movie-panel .meta-list ul > li:last-child:after {
    content: '';
  }
  .movie-panel .genre {
    font-style: italic;
  }
  .movie-panel .plot-wrap {
    clear: both;
    padding: 15px 0 0;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3; /* number of lines to show */
    line-height: 22px;        /* fallback */
    max-height: 66px;       /* fallback */
  }
  .movie-panel .consensus-wrap {
    margin-top: 14px;
    border-top: 1px solid #eaeaea;
    padding: 14px 0 0;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3; /* number of lines to show */
    line-height: 22px;        /* fallback */
    max-height: 66px;       /* fallback */
    margin-bottom: 20px;
  }
  .movie-panel .trailer-link {
    width: 49%;
    margin-top: 25px;
    height: 45px;
    line-height: 45px;
    padding: 0 10px;
    background: #2c3f4f;
    color: #fff;
    font-size: 1.1em;
    margin-bottom: 5px;
  }
  .movie-panel .watch-this {
    width: 49%;
    margin-top: 25px;
    height: 45px;
    line-height: 45px;
    padding: 0 10px;
    background: #2a6585;
    color: #fff;
    font-size: 1.2em;
    margin-bottom: 5px;
  }
  /*.movie-panel .watch-this.no-links {
    opacity: 0.2;
  }*/
  .movie-panel .watch-this i {
    margin-right: 10px;
    font-size: 16px;
  }
  .movie-panel .small-button {
    width: 32.35%;
    float: left;
    margin: 0 2px 5px;
    font-size: 14px;
    padding: 10px 4px;
  }
  .movie-panel .small-button i {
    margin-right: 4px;
  }
  .pure-button.add-to-list-link {
    background: #5d97bc;
    color: #fff;
  }
  .pure-button.rate-film-link {
    background: #4786ad;
    color: #fff;
  }
  .pure-button.rate-button-is-rated {
    background: #36a731;
    padding: 8px 4px 7px;
  }
  .pure-button.rate-button-is-rated span {
    font-size: 18px;
    font-weight: bold;
    display: inline-block;
    vertical-align: -1px;
    margin-left: 2px;
  }
  .pure-button.add-note-link {
    background: #3a88b8;
    color: #fff;
  }
  .movie-panel .small-button.first-small-button {
    margin-left: 0;
  }
  .movie-panel .small-button.last-small-button {
    margin-right: 0;
  }
  @media only screen and (max-width: 320px) {
    .movie-panel .quality-square {
      width: 40px;
    }
    .movie-panel .quality-square span {
      font-size: 0.7em;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/MoviePanel.vue